export enum TaxScope {
    SALE = 'sale',
    PURCHASE = 'purchase',
    PAYMENT = 'payment',
    FOR_ALL = 'for_all'
}
